/* eslint-disable no-secrets/no-secrets */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PolicyDetailsPage as TWIARenewalPolicyDetailsPage,
    PaymentDetailsPage as TWIARenewalPaymentDetailsPage
  } from 'twia-capability-renewal-common-react';
import TWIARenewalCoverageSummaryPage from "twia-capability-quoteandbind-residential-react/pages/CoverageSummary/CoverageSummaryPage";
import TWIARenewalAdditionalInformationPage from '../twia-capability-quoteandbind-TWIAResidential-react/pages/AdditionalInformation/AdditionalInformationPage.jsx';
import TWIARenewalPropertyDetailsPage from '../twia-capability-quoteandbind-TWIAResidential-react/pages/PropertyDetails/PropertyDetailsPage.jsx';
import TWIARenewalConstructionPage from '../twia-capability-quoteandbind-TWIAResidential-react/pages/Construction/ConstructionPage.jsx';
import TWIARenewalQuotePage from '../twia-capability-quoteandbind-TWIAResidential-react/pages/Quote/QuotePage';


setComponentMapOverrides(
    {
        TWIARenewalPolicyDetailsPage: { component: 'TWIARenewalPolicyDetailsPage' },
        TWIARenewalPropertyDetailsPage: { component: 'TWIARenewalPropertyDetailsPage' },
        TWIARenewalConstructionPage: { component: 'TWIARenewalConstructionPage' },
        TWIARenewalQuotePage: { component: 'TWIARenewalQuotePage' },
        TWIARenewalAdditionalInformationPage: { component: 'TWIARenewalAdditionalInformationPage' },
        TWIARenewalCoverageSummaryPage: { component: 'TWIARenewalCoverageSummaryPage' },
        TWIARenewalPaymentDetailsPage: { component: 'TWIARenewalPaymentDetailsPage' },
    },
    {
        TWIARenewalPolicyDetailsPage,
        TWIARenewalPropertyDetailsPage,
        TWIARenewalConstructionPage,
        TWIARenewalQuotePage,
        TWIARenewalAdditionalInformationPage,
        TWIARenewalCoverageSummaryPage,
        TWIARenewalPaymentDetailsPage,
    }
);


export { default as TWIAResidentialRenewalWizard } from './TWIAResidentialRenewalWizard.jsx';
export { default as TWIAAccountHolderEdit } from './components/TWIAAccountHolderEdit/TWIAAccountHolderEdit.jsx';
